import React, { useState, useEffect } from "react";
import {
  CapturaDocumento,
  CapturaSelfie,
  Lobby,
  Switch,
  VideoRoomComponent,
} from "@components";
import { useSearchParameters } from "@hooks";
import { getLocalStorageItem } from "@utils";
import { verificaDocumentosColetaPrevia } from "@services";

const obterColetaPreviaRealizada = (status) => {
  return {
    selfie: Boolean(status?.selfieEnviada),
    documento: Boolean(status?.documentoEnviado),
  };
};

const obterTipoUsuario = (searchParameters) =>
  searchParameters.userType ?? getLocalStorageItem("USERTYPE") ?? "cliente";

const AppContainer = () => {
  const searchParameters = useSearchParameters();
  const userType = obterTipoUsuario(searchParameters);
  const [screenToShow, setScreenToShow] = useState(() =>
    userType === "agr" ? "lobby" : "captura-selfie",
  );
  const [sessionId, setSessionId] = useState();
  const [cpf, setCpf] = useState();
  const [coletaPreviaRealizada, setColetaPreviaRealizada] = useState({
    selfie: false,
    documento: false,
  });

  useEffect(() => {
    const { session, cpf } = searchParameters;
    setSessionId(session);
    setCpf(cpf);

    if (userType === "agr") {
      return;
    }

    const definirTelaInicialCliente = async () => {
      try {
        const status = await verificaDocumentosColetaPrevia({
          idSolicitacao: session,
        });
        const realizada = obterColetaPreviaRealizada(status);
        setColetaPreviaRealizada(realizada);

        if (realizada.selfie && realizada.documento) {
          setScreenToShow("lobby");
        } else if (realizada.selfie) {
          setScreenToShow("captura-documento");
        } else {
          setScreenToShow("captura-selfie");
        }
      } catch (error) {
        setScreenToShow("captura-selfie");
      }
    };

    definirTelaInicialCliente();
  }, [searchParameters, userType]);

  return (
    <Switch value={screenToShow}>
      <CapturaSelfie
        value="captura-selfie"
        idSolicitacao={sessionId}
        cpf={cpf}
        setScreenToShow={setScreenToShow}
        telaSeguinte={
          coletaPreviaRealizada.documento ? "lobby" : "captura-documento"
        }
      />
      <CapturaDocumento
        value="captura-documento"
        idSolicitacao={sessionId}
        cpf={cpf}
        setScreenToShow={setScreenToShow}
      />
      <Lobby
        value="lobby"
        setScreenToShow={setScreenToShow}
        setSessionId={setSessionId}
        userType={userType}
      />
      <VideoRoomComponent
        value="videoconferencia"
        sessionId={sessionId}
        userType={userType}
      ></VideoRoomComponent>
    </Switch>
  );
};

export default AppContainer;
